// React imports.
import React from "react";

//app imports
import {Assessment2FuelStatusEnum} from "../state";

const VendorsReportedTableRow = ({ state, fuel, step, fieldChangeHandler, rowClass  }) => (
    <React.Fragment>
        <div className={"dwGridRow col1 "+ rowClass}>{fuel.description}</div>
        {step.showTotalVendors === true &&
            <div className={"dwGridRow yellow-background col2 "+ rowClass}>
                <input id="numTotalVendors" value={fuel.numTotalVendors} 
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {(step.showVendorsRequested === true && fuel.numTotalVendors !== 0)&&

            <div className={"dwGridRow yellow-background col3 "+ rowClass}>
                <input id="numRequestedVendors" value={fuel.numRequestedVendors} 
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)}
                    className="form-control "  />
            </div>
        }
        {(step.showVendorsRequested === true && fuel.numTotalVendors === 0)&&

            <div className={"dwGridRow  col3 "+ rowClass}>
                N/A
            </div>
        }
        {(step.showVendorsReceived === true  && fuel.numTotalVendors !== 0) &&
            <div className={"dwGridRow yellow-background col4 "+ rowClass}>
                <input id="numReceivedVendors" value={fuel.numReceivedVendors }
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {(step.showVendorsReceived === true && fuel.numTotalVendors === 0)&&

            <div className={"dwGridRow  col4 "+ rowClass}>
                N/A
            </div>
        }

        {(step.showStatus === true && fuel.numTotalVendors === 0)&&
            <div className={"dwGridRow  col5 "+ rowClass}>
                N/A – You indicated that you do not serve  {fuel.description}  households.
            </div>
        }
        {(step.showStatus === true && fuel.numRequestedVendors === '')
            &&<div className={"dwGridRow red-background col5 "+ rowClass}>
                <span>
                    <strong>Potential issue –</strong>
                    You did not report the number of vendors
                    from whom you requested  {fuel.description}  data.
                </span>
              </div>
        }
        {(step.showStatus === true
          && fuel.numRequestedVendors != ''
          && fuel.numReceivedVendors == '')
            &&<div className={"dwGridRow red-background col5 "+ rowClass}>
                <span>
                    <strong>Potential issue –</strong>
                    You did not report the number of vendors
                    supplying  {fuel.description}  data.
                </span>
              </div>
        }

        {(step.showStatus === true  && fuel.numTotalVendors !== 0) &&
            <React.Fragment>

                {(fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.OverMinNoIssues
                    ||fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.UnderMinNoIssues)
                    &&<div className={"dwGridRow green-background col5 "+ rowClass}>
                        <span>
                            <strong>No Issue Flagged –</strong> You both requested and received data from enough  {fuel.description}  vendors.
                        </span>
                      </div>
                }


                {(fuel.vendorsSubmittingDataStatus!= null
                  && (fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.OverMinNotEnoughRequested
                    || fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.UnderMinNotEnoughRequested))
                    &&<div className={"dwGridRow red-background col5 "+ rowClass}>
                          <span>
                            <strong>Potential issue – </strong>
                            You did not request data from enough  {fuel.description}  vendors.
                          </span>
                      </div>
                }

                {(fuel.vendorsSubmittingDataStatus!= null
                  && (fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.OverMinNotEnoughReceived
                    || fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.UnderMinNotEnoughReceived))
                    &&<div className={"dwGridRow red-background col5 "+ rowClass}>
                          <span>
                            <strong>Potential issue – </strong>
                            You did not receive data from enough  {fuel.description}  vendors.
                          </span>
                      </div>
                }


                {(fuel.vendorsSubmittingDataStatus!= null
                  && fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.RequestedMoreThanTotal)
                    &&<div className={"dwGridRow red-background col5 "+ rowClass}>
                          <span>
                              <strong>Error – </strong>
                              You reported requesting data from more  {fuel.description}  vendors
                              than you reported serving your state.
                          </span>
                      </div>
                }

                {(fuel.vendorsSubmittingDataStatus!= null
                  && fuel.vendorsSubmittingDataStatus ==Assessment2FuelStatusEnum.ReceivedMoreThanTotal)
                    &&<div className={"dwGridRow red-background col5 "+ rowClass}>
                          <span>
                              <strong>Error – </strong>
                              You reported receiving data from more  {fuel.description}  vendors
                              than you requested data from.
                          </span>
                      </div>
                }

            </React.Fragment>
        }
        
    </React.Fragment>
);

export default VendorsReportedTableRow;
